import { FEATURE_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations';
import {
    isD2CAccount,
    isEnterpriseAccount,
    isGrowthWithoutLowTouchAccount,
} from '../../account-management/accountType';

export const ACCESS_RULES = {
    ENTERPRISE_OR_GROWTH: [isEnterpriseAccount, isGrowthWithoutLowTouchAccount],
    ENTERPRISE_OR_D2C: [isEnterpriseAccount, isD2CAccount],
};

export const FEATURE_ACCESS_RULES = {
    [FEATURE_FLAGS.CREATIVE_FORM_LOGO_FIELD_ENABLED]: ACCESS_RULES.ENTERPRISE_OR_D2C,
    [FEATURE_FLAGS.DISPLAY_ITEM_ENABLED]: ACCESS_RULES.ENTERPRISE_OR_GROWTH,
    [FEATURE_FLAGS.SHOULD_SHOW_DISPLAY_DATA]: ACCESS_RULES.ENTERPRISE_OR_GROWTH,
    [FEATURE_FLAGS.IS_DISPLAY_FILTERS_ENABLED]: ACCESS_RULES.ENTERPRISE_OR_GROWTH,
};
